import { render, staticRenderFns } from "./HouseDetails.vue?vue&type=template&id=0b6af2ba&scoped=true&"
import script from "./HouseDetails.vue?vue&type=script&lang=js&"
export * from "./HouseDetails.vue?vue&type=script&lang=js&"
import style0 from "./HouseDetails.vue?vue&type=style&index=0&id=0b6af2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6af2ba",
  null
  
)

export default component.exports